<template>
  <Teleport to="body">
    <div v-if="visible" class="fixed inset-0 z-50 overflow-y-auto">
      <!-- 遮罩层 -->
      <div class="fixed inset-0 bg-black/50 transition-opacity" @click="handleClose"></div>

      <!-- 弹窗主体 -->
      <div class="flex min-h-full items-center justify-center p-4">
        <div class="relative w-full max-w-3xl bg-white rounded-2xl shadow-xl transform transition-all max-h-[90vh] flex flex-col">
          <!-- 头部 -->
          <div class="flex items-center justify-between px-6 py-4 border-b border-slate-200 flex-shrink-0">
            <h3 class="text-lg font-semibold text-slate-900">{{ isEdit ? '编辑分账账户' : '创建分账账户' }}</h3>
            <button
              @click="handleClose"
              class="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>

          <!-- 表单内容 -->
          <div class="flex-1 overflow-y-auto p-6">
            <el-form
              ref="formRef"
              :model="formData"
              :rules="rules"
              label-width="120px"
              class="space-y-6"
            >
              <!-- 基本信息 -->
              <div class="bg-slate-50 rounded-xl p-4">
                <h4 class="text-sm font-medium text-slate-700 mb-4 flex items-center gap-2">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                  基本信息
                </h4>

                <el-form-item label="分账接收方" prop="receiverName">
                  <input
                    v-model="formData.receiverName"
                    type="text"
                    placeholder="请输入分账接收方名称"
                    class="form-input w-full"
                  >
                </el-form-item>

                <el-form-item label="联系手机" prop="contactMobile">
                  <input
                    v-model="formData.contactMobile"
                    type="text"
                    placeholder="请输入联系电话"
                    class="form-input w-full"
                  >
                </el-form-item>
              </div>

              <!-- 账户类型 -->
              <div class="bg-slate-50 rounded-xl p-4">
                <h4 class="text-sm font-medium text-slate-700 mb-4 flex items-center gap-2">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
                  </svg>
                  收款账户信息
                </h4>

                <el-form-item label="账户类型" prop="acctTypeCode">
                  <select
                    v-model="formData.acctTypeCode"
                    :disabled="isEdit"
                    class="form-select-native w-full"
                  >
                    <option value="">请选择账户类型</option>
                    <option value="57">对公账户</option>
                    <option value="58">对私账户</option>
                  </select>
                </el-form-item>

                <el-form-item label="收款账户名" prop="acctName">
                  <input
                    v-model="formData.acctName"
                    type="text"
                    placeholder="请输入收款账户名称"
                    class="form-input w-full"
                  >
                </el-form-item>

                <el-form-item label="收款账号" prop="acctNo">
                  <input
                    v-model="formData.acctNo"
                    type="text"
                    placeholder="请输入收款账户卡号"
                    class="form-input w-full font-mono"
                  >
                </el-form-item>

                <div class="grid grid-cols-2 gap-4">
                  <el-form-item label="开户行号" prop="acctOpenBankCode">
                    <input
                      v-model="formData.acctOpenBankCode"
                      type="text"
                      placeholder="请输入开户行号"
                      class="form-input w-full"
                    >
                  </el-form-item>

                  <el-form-item label="清算行行号" prop="acctClearBankCode">
                    <input
                      v-model="formData.acctClearBankCode"
                      type="text"
                      placeholder="请输入清算行行号"
                      class="form-input w-full"
                    >
                  </el-form-item>
                </div>

                <el-form-item label="开户行名称" prop="acctOpenBankName">
                  <input
                    v-model="formData.acctOpenBankName"
                    type="text"
                    placeholder="请输入开户行名称"
                    class="form-input w-full"
                  >
                </el-form-item>

                <el-form-item label="账户证件类型" prop="acctCertificateType">
                  <select
                    v-model="formData.acctCertificateType"
                    class="form-select-native w-full"
                  >
                    <option value="">请选择证件类型</option>
                    <option value="01">身份证</option>
                    <option value="02">营业执照</option>
                    <option value="03">统一社会信用代码</option>
                  </select>
                </el-form-item>

                <el-form-item label="账户证件号" prop="acctCertificateNo">
                  <input
                    v-model="formData.acctCertificateNo"
                    type="text"
                    placeholder="请输入账户证件号"
                    class="form-input w-full font-mono"
                  >
                </el-form-item>
              </div>

              <!-- 营业执照信息（对公账户必填） -->
              <div v-if="formData.acctTypeCode === '57'" class="bg-amber-50 rounded-xl p-4">
                <h4 class="text-sm font-medium text-amber-800 mb-4 flex items-center gap-2">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                  </svg>
                  营业执照信息
                </h4>

                <el-form-item label="营业执照号" prop="licenseNo">
                  <input
                    v-model="formData.licenseNo"
                    type="text"
                    placeholder="请输入营业执照号码"
                    class="form-input w-full"
                  >
                </el-form-item>

                <el-form-item label="营业执照名" prop="licenseName">
                  <input
                    v-model="formData.licenseName"
                    type="text"
                    placeholder="请输入营业执照名称"
                    class="form-input w-full"
                  >
                </el-form-item>
              </div>

              <!-- 法人信息（对公账户必填） -->
              <div v-if="formData.acctTypeCode === '57'" class="bg-amber-50 rounded-xl p-4">
                <h4 class="text-sm font-medium text-amber-800 mb-4 flex items-center gap-2">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                  </svg>
                  法人信息
                </h4>

                <el-form-item label="法人姓名" prop="legalPersonName">
                  <input
                    v-model="formData.legalPersonName"
                    type="text"
                    placeholder="请输入法人姓名"
                    class="form-input w-full"
                  >
                </el-form-item>

                <div class="grid grid-cols-2 gap-4">
                  <el-form-item label="法人证件类型" prop="legalPersonCertificateType">
                    <select
                      v-model="formData.legalPersonCertificateType"
                      class="form-select-native w-full"
                    >
                      <option value="">请选择证件类型</option>
                      <option value="01">身份证</option>
                      <option value="02">护照</option>
                    </select>
                  </el-form-item>

                  <el-form-item label="法人证件号" prop="legalPersonCertificateNo">
                    <input
                      v-model="formData.legalPersonCertificateNo"
                      type="text"
                      placeholder="请输入法人证件号"
                      class="form-input w-full font-mono"
                    >
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>

          <!-- 底部按钮 -->
          <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-2xl flex-shrink-0">
            <button
              @click="handleClose"
              class="px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-100 transition-colors"
            >
              取消
            </button>
            <button
              @click="handleSubmit"
              :disabled="submitting"
              class="btn-primary"
            >
              <span v-if="submitting">保存中...</span>
              <span v-else>保存</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, reactive, watch, computed } from 'vue'
import { ElMessage } from 'element-plus'
import { createReferrerLakalaReceiver, updateReferrerLakalaReceiver } from '@/api/commission'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  referrerId: {
    type: [Number, String],
    default: null
  },
  accountData: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['update:visible', 'success'])

const formRef = ref(null)
const submitting = ref(false)

// 是否是编辑模式
const isEdit = computed(() => !!props.accountData)

// 表单数据
const getInitialFormData = () => ({
  referrerId: null,
  receiverName: '',
  contactMobile: '',
  licenseNo: '',
  licenseName: '',
  legalPersonName: '',
  legalPersonCertificateType: '',
  legalPersonCertificateNo: '',
  acctNo: '',
  acctName: '',
  acctTypeCode: '',
  acctCertificateType: '',
  acctCertificateNo: '',
  acctOpenBankCode: '',
  acctOpenBankName: '',
  acctClearBankCode: ''
})

const formData = reactive(getInitialFormData())

// 验证规则
const rules = computed(() => {
  const baseRules = {
    receiverName: [
      { required: true, message: '请输入分账接收方名称', trigger: 'blur' }
    ],
    contactMobile: [
      { required: true, message: '请输入联系手机号', trigger: 'blur' },
      { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
    ],
    acctTypeCode: [
      { required: true, message: '请选择账户类型', trigger: 'change' }
    ],
    acctName: [
      { required: true, message: '请输入收款账户名称', trigger: 'blur' }
    ],
    acctNo: [
      { required: true, message: '请输入收款账户卡号', trigger: 'blur' }
    ],
    acctOpenBankCode: [
      { required: true, message: '请输入开户行号', trigger: 'blur' }
    ],
    acctOpenBankName: [
      { required: true, message: '请输入开户行名称', trigger: 'blur' }
    ]
  }

  // 对公账户额外的验证
  if (formData.acctTypeCode === '57') {
    baseRules.licenseNo = [
      { required: true, message: '对公账户请输入营业执照号', trigger: 'blur' }
    ]
    baseRules.licenseName = [
      { required: true, message: '对公账户请输入营业执照名称', trigger: 'blur' }
    ]
    baseRules.legalPersonName = [
      { required: true, message: '对公账户请输入法人姓名', trigger: 'blur' }
    ]
    baseRules.legalPersonCertificateType = [
      { required: true, message: '对公账户请选择法人证件类型', trigger: 'change' }
    ]
    baseRules.legalPersonCertificateNo = [
      { required: true, message: '对公账户请输入法人证件号', trigger: 'blur' }
    ]
  }

  return baseRules
})

// 重置表单
const resetForm = () => {
  if (props.accountData) {
    // 编辑模式 - 填充已有数据
    Object.keys(getInitialFormData()).forEach(key => {
      let value = props.accountData[key] ?? getInitialFormData()[key]
      // API 返回的 acctTypeCode 可能是整数，需要转为字符串用于表单判断
      if (key === 'acctTypeCode' && value !== null && value !== undefined) {
        value = String(value)
      }
      formData[key] = value
    })
  } else {
    // 新增模式
    const initial = getInitialFormData()
    Object.keys(initial).forEach(key => {
      formData[key] = initial[key]
    })
    formData.referrerId = props.referrerId
  }
}

// 关闭弹窗
const handleClose = () => {
  resetForm()
  emit('update:visible', false)
}

// 提交表单
const handleSubmit = async () => {
  try {
    await formRef.value.validate()
    submitting.value = true

    // 构建提交数据
    const submitData = {
      ...formData,
      // 编辑时包含 id
      ...(isEdit.value ? { id: props.accountData.id } : {})
    }

    if (isEdit.value) {
      // 编辑模式
      await updateReferrerLakalaReceiver(submitData)
      ElMessage.success('更新成功')
    } else {
      // 新增模式
      await createReferrerLakalaReceiver(submitData)
      ElMessage.success('创建成功')
    }

    emit('success')
    handleClose()
  } catch (error) {
    console.error('保存分账账户失败:', error)
    if (error !== false) {
      ElMessage.error(error.message || '保存失败')
    }
  } finally {
    submitting.value = false
  }
}

// 监听弹窗显示
watch(() => props.visible, (val) => {
  if (val) {
    resetForm()
  }
})
</script>
